@if (field.sequentialView && isLanding) {
  <div class="common-text-input__container-field-sequential">
    <field-sequential-header [field]="field"></field-sequential-header>
    <div class="common-scales__container-list-sequential">
      @for (listValue of fieldTypeList.filterList; track $index){
        <button class="common-scales__list-item-sequential"
          [ngClass]=" {'common-scales__list-item-sequential--selected': listValue.selected,
            'common-scales__list-item-sequential--error': field.error }"
          (click)="selectItem(listValue)"
          [disabled]="listValue.disabled || field.noEditable">
          <span-tooltip class="common-scales__item-text-sequential"
            [text]="listValue.text"></span-tooltip>
        </button>
      }
    </div>
    @if (field.error) {
      <div class="common-text-input__mandatory-tag">
        @if (field.blocker) {
          <i class="lf-icon-warning common-icon__error-md"></i>
        }
        <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
      </div>
    }
  </div>
}@else {
  <div class="common-text-input__container"
    [id]="fieldTypeList.id">
    <div class="common-text-input__container-box-no-hover-special"
      [ngClass]="{'common-text-input__container-box-no-hover-special--error': field.error}"
      [attr.disabled]="field.noEditable?true:null">
      <div class="common-text-input__block-header">
        <div class="common-text-input__label-no-cursor">
          <span class="common-text-input__text-label">{{fieldTypeList.titleField}}</span>
          @if(field.required){
            <span class="common-tag__mandatory-text-asterisk">*</span>
          }
          <div class="common-text-input__block-buttons">
            @if (field.description) {
              <tooltip-info [description]="field.description"
              [field]="field"></tooltip-info>
            }
            @if (field.references?.length) {
              <tooltip-law [references]="field.references"
              [field]="field"></tooltip-law>
            }
              @if (field.relatedInfo?.length){
                <button class="common-button__icon-sm-noborder"
                    pTooltip="{{'common.related-info'| afTranslate}}"
                    tooltipPosition="top"
                    (click)="openModalRelatedInfo(field.relatedInfo)">
                    <i class="lf-icon-search-text common-icon__md"></i>
                </button>
              }
              @if (field.inReport !== null && field.inReport !== undefined && !isLanding){
                <tooltip-in-report [inReport]="fieldTypeList.inReport"></tooltip-in-report>
              }
          </div>
        </div>
      </div>
      <div class="common-scales__list-block"
        [ngClass]=" {'common-scales__list-block--disabled': field.noEditable}">
        @for (listValue of fieldTypeList.filterList; track $index){
          <button class="common-scales__list-item"
            [ngClass]=" {'common-scales__list-item--active': listValue.selected,
              'common-scales__list-item--disabled': field.noEditable }"
            (click)="selectItem(listValue)"
            [disabled]="listValue.disabled || field.noEditable">
            <span-tooltip class="common-scales__item-text"
              [ngClass]=" {'common-scales__item-text--separator': !$first && !listValue.selected}"
              [text]="listValue.text"></span-tooltip>
          </button>
        }
      </div>
    </div>
    @if(field.error){
      <div class="common-text-input__mandatory-tag">
        @if(field.blocker){
          <i class="lf-icon-warning common-icon__error-md"></i>
        }
        <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
      </div>
    }
  </div>
}
